import { TextLink } from "./TextLink.js";

export default TextLink;
